export enum InputType {
  INPUT = "input",
  TEXT_AREA = "textarea"
}
